
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    click: Function,
    linkLabel: String,
    linkLabel2: String,
    classComponent: String,
    classComponent2: String,
    classComponentIcon: String,
    linkHref: String,
    icon: String,
    classDiv: String,
  },
})
export default class TextLink extends Vue {}
